module.exports = __webpack_public_path__ + "static/media/Протокол от проведеното на 28.06.2023 г. ОСА на Формопласт АД.83078078.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2023/Протокол от проведеното на 28.06.2023 г. ОСА на Формопласт АД.pdf
// module id = 97
// module chunks = 0